import React from 'react'
import Page from '../../components/page/Page'
import BlogView from '../../components/blogs/BlogView'

const blogs = [
    {
        id: 1,
        image: '',
        title: '',
        description: '',
        date: '',
    },
]

const Index = () => {
    return (
        <Page
            banners={false}
            id={'BlogPage'}
            title="News and Stories"
            pageTitle="News and Stories"
            breadcrumbs={[
                {
                    title: 'Home',
                    link: '/',
                },
                {
                    title: 'Blogs',
                    link: '/blogs',
                },
            ]}
        >
            <BlogView blogs={blogs} />
        </Page>
    )
}

export default Index
